import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newCountryCreation } from "./CreateCountryAction";
import { useDispatch, useSelector } from "react-redux";
import * as bootstrap from 'bootstrap';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useNavigate, Link } from 'react-router-dom';
import { getAllCountry} from "./countryListAction";
import { FaArrowLeft } from 'react-icons/fa';

const initialState = {
  country: "",
  status: "",

}


const CreateCountry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [newCountry, setNewCountry] = useState(initialState);
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();

  const { iscLoading, cstatus, cmessage } = useSelector((state) => state.countryList);
  
  useEffect(() => { }, [newCountry]);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    // console.log('name '+name); 
    //console.log('value '+value); 
    setNewCountry({ ...newCountry, [name]: value });

   
 
  };
  useEffect(() => {
    dispatch(getAllCountry());
   
}, [dispatch,cmessage]);

  const onSubmit = (data, e) => {
    e.preventDefault();
  
    Swal.fire('Country Created Successfully!', '', 'success');
  
    const { country, status } = newCountry;
    const newUserCreation1 = {
      country,
      status
    };
  
    dispatch(newCountryCreation(newUserCreation1));
    navigate('/countryList');
    e.target.reset();
  };
  
  const canSave = Boolean (newCountry.country) && Boolean(newCountry.status)
  
  return (
    <>
      
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Country</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/countryList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            {/* <Row>
              <Col>
                {cmessage && (<Alert variant={cstatus === "success" ? "success" : "danger"}>{cmessage}</Alert>)}
              </Col>
            </Row> */}
            <Form className=" mx-4 my-2" component="form"  noValidate  autoComplete="off" onSubmit={handleSubmit(onSubmit)}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridCountry">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text"  name="country" required autoComplete='off' placeholder="Enter Country Name" {...register("country", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                  {errors.country && <p className='text-danger'>Country name required</p>}
                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
                Submit
              </Button>
              </div>
              {iscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
         
    </>
  );
}

export default CreateCountry;


